import { useState, useContext } from "react";
import TemplateContext from "@/context/Template/TemplateContext";
import { RecipesIAContainer } from "./styles";
import ContentIcon from "@/shared/ContentIcon";
import { useChat } from "./hooks/useChat";

const RecipesIA = () => {
  const { messages, loading, error, userMessage, setUserMessage, handleForm } =
    useChat();

  const dataContext = useContext(TemplateContext);
  const { userProfile } = dataContext?.content || {};

  return (
    <RecipesIAContainer>
      <div className="recipes-ia-info">
        <figure className="recipes-ia-icon">
          <img src="https://www.clarin.com/frontcdn//pages/2025/01/21/chef.png" />
        </figure>
        <div className="recipes-ia-text">
          <div className="recipes-ia-text-title">Clari</div>
          <div className="recipes-ia-text-content">
            Tu chef personal para encontrar recetas. ​
          </div>
          <div className="recipes-ia-text-content">¿Qué querés cocinar hoy?​</div>
        </div>
      </div>
      <div className="recipes-ia-chat-container">
        <div className="recipes-ia-chat">
          {messages.map(({ message, type }, index) => (
            <div className={`recipes-ia-chat-bubble type-${type}`}>
              {type === "ia" ? (
                <figure className="recipes-ia-chat-icon">
                  <img src="https://www.clarin.com/frontcdn//pages/2025/01/21/chef.png" />
                </figure>
              ) : null}
              <div
                key={index}
                className={`recipes-ia-chat-message type-${type}`}
                dangerouslySetInnerHTML={{__html: message}}
              >
              </div>
              {type === "user" ? (
                <picture className={`recipes-ia-chat-icon type-${type}`}>
                  {userProfile?.picture && (
                    <img
                      alt="avatar usuario"
                      src={userProfile?.picture}
                      className="container-user-avatar"
                    />
                  )}
                </picture>
              ) : null}
            </div>
          ))}
          {error && <p className="recipes-ia-error">{error}</p>}
          {loading && (
            <div className="recipes-ia-loading-chat">
              <figure className="recipes-ia-chat-icon">
                <img src="https://www.clarin.com/frontcdn//pages/2025/01/21/chef.png" />
              </figure>
              <div class="recipes-ia-loading-container">
                <div class="recipes-ia-loading">
                  <div class="recipes-ia-spinner">
                    <div class="recipes-ia-bounce1"></div>
                    <div class="recipes-ia-bounce2"></div>
                    <div class="recipes-ia-bounce3"></div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="recipes-ia-input-container">
          <form className="recipes-ia-form" onSubmit={handleForm}>
            <input
              placeholder="Preguntame"
              className="recipes-ia-input"
              type="text"
              value={userMessage}
              onChange={(e) => setUserMessage(e.target.value)}
            />
            <button className="recipes-ia-input-button" type="">
              <ContentIcon
                width="22px"
                height="22px"
                nameIcon="arrow-recipes"
                fill="#000"
              />
            </button>
          </form>
        </div>
      </div>
    </RecipesIAContainer>
  );
};

export default RecipesIA;
